<template>
  <div>
    <SellHeader :img_header="header_image" header="คำสั่งซื้อ" link_back="sell/ordercustomermain"/>
    <Pay_customer_incorrect/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/agreement.png";
import Pay_customer_incorrect from "@/components/admin/sell/Pay_customer_incorrect";
export default {
  name: "PayCustomerIncorrect",
  components: {
    Pay_customer_incorrect,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
